export default {
    RESERVATION_EDIT_ROOM_SETUP_GET_RESERVATION_REQUEST: 'RESERVATION_EDIT_ROOM_SETUP_GET_RESERVATION_REQUEST',
    RESERVATION_EDIT_ROOM_SETUP_GET_RESERVATION_SUCCESS: 'RESERVATION_EDIT_ROOM_SETUP_GET_RESERVATION_SUCCESS',
    RESERVATION_EDIT_ROOM_SETUP_UPDATE_RESERVATION_REQUEST: 'RESERVATION_EDIT_ROOM_SETUP_UPDATE_RESERVATION_REQUEST',
    RESERVATION_EDIT_ROOM_SETUP_UPDATE_RESERVATION_SUCCESS: 'RESERVATION_EDIT_ROOM_SETUP_UPDATE_RESERVATION_SUCCESS',
    RESERVATION_EDIT_ROOM_SETUP_SEARCH_INVENTORY_ITEMS_REQUEST:
        'RESERVATION_EDIT_ROOM_SETUP_SEARCH_INVENTORY_ITEMS_REQUEST',
    RESERVATION_EDIT_ROOM_SETUP_SEARCH_INVENTORY_ITEMS_SUCCESS:
        'RESERVATION_EDIT_ROOM_SETUP_SEARCH_INVENTORY_ITEMS_SUCCESS',
    RESERVATION_EDIT_ROOM_SETUP_DISPOSE_STORE: 'RESERVATION_EDIT_ROOM_SETUP_DISPOSE_STORE',
};
